<script lang="ts">

  import { page } from "$app/state"
  import { Button } from "$lib/components/ui/button"
  import XIcon from "@lucide/svelte/icons/x"

  const prefix = $derived(page.params.prefix ?? "0")

</script>

<main class="overflow-auto relative mx-auto h-full max-w-3xl">
  <nav class="sticky w-full top-0 inset-s-0 inset-e-0 z-10 bg-background border-b max-w-3xl">
    <div class="flex h-12 items-center justify-between px-3">
      <div class="flex items-center">
        <Button
          href={`/${prefix}/home`}
          variant="ghost"
          size="icon"
          class="me-2 rounded-full"
          aria-label="Kembali">
          <XIcon aria-hidden="true"/>
        </Button>
        <h1 class="text-lg font-medium">Rekap Hasil</h1>
      </div>
      <div></div>
    </div>
  </nav>
  <div class="min-h-full">
    <div class="flex h-dvh items-center justify-center">
      <div>Dalam pengembangan</div>
    </div>
  </div>
</main>
